import { apiClient, omrehBaseClient } from "./client";
const GetAll = () => {
    return omrehBaseClient
        .get("/Company");
}
const CompanyCodeDropDown = () => {
    return omrehBaseClient
        .get("/Company/CompanyCodeDropDown");
}
const companyApi = { GetAll, CompanyCodeDropDown }
export default companyApi;